exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-dialog .el-dialog__header[data-v-71c840ba]{background:#f5f5f5;-webkit-box-shadow:0px 1px 0px 0px #eeeeee;box-shadow:0px 1px 0px 0px #eeeeee}.custom-dialog .el-dialog__footer[data-v-71c840ba]{text-align:center}\n", ""]);

// exports
